export enum GroupMarketingPreferencesFormField {
  GroupMarketingConsent = 'groupMarketingConsent',
  GroupMarketingPreferences = 'groupMarketingPreferences',
}
